import * as React from 'react';
import {
    Button,
    Checkbox,
    CircularProgress,
    Container,
    FormControlLabel,
    List,
    ListItem,
    ListItemText,
    Paper,
    Typography
} from '@mui/material';
import {actions as opportunityActions, selectors as opportunitySelectors} from '../../../../../Ducks/opportunity';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {selectors as accountSelectors} from '../../../../../Ducks/account';
import {useNavigate, useParams} from 'react-router-dom';
import {ViewState} from '@devexpress/dx-react-scheduler';
import {
    Appointments,
    AppointmentTooltip,
    DateNavigator,
    DayView,
    MonthView,
    Resources,
    Scheduler,
    TodayButton,
    Toolbar,
    WeekView
} from '@devexpress/dx-react-scheduler-material-ui';
import AddOpportunityActionModal from './AddOpportunityActionModal';
import moment from 'moment';
import {styled} from '@mui/material/styles';
import {
    ACCEPTED, ACTION_STATUS_COLORS,
    ADD, DECLINED,
    EDIT,
    FOLLOW_UP,
    PENDING,
    PLANNED_ACTION,
    TENTATIVE
} from "../../../../Utils/constants";
import {actions as contactActions, selectors as contactSelectors} from '../../../../../Ducks/contacts';
import {ParticipationStatus} from "../../../../Utils/commonUtils";

const ShowProgress = () => (
    <div style={{display: 'flex', justifyContent: 'center'}}>
        <CircularProgress/>
    </div>
)

const PREFIX = 'Demo';

const classes = {
    dayScaleCell: `${PREFIX}-dayScaleCell`,
};

const StyledWeekViewDayScaleCell = styled(WeekView.DayScaleCell)({
    [`&.${classes.dayScaleCell}`]: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
});

const formatDayScaleDate = (date, options) => {
    const momentDate = moment(date);
    const {weekday} = options;
    return momentDate.format(weekday ? 'ddd' : 'D');
};
const formatTimeScaleDate = date => moment(date).format('HH:mm');

const DayScaleCell = ((
    {formatDate, ...restProps},
) => (
    <StyledWeekViewDayScaleCell
        {...restProps}
        formatDate={formatDayScaleDate}
        className={classes.dayScaleCell}
    />
));

const TimeScaleLabel = (
    {formatDate, ...restProps},
) => <WeekView.TimeScaleLabel {...restProps} formatDate={formatTimeScaleDate}/>;

const ParticipantList = styled(List)`
    padding: 0 !important;
`;

const ParticipantItem = styled(ListItem)`
    padding: 0 !important;
`;

class Demo extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            data: props.events ? this.appointmentsData(props.events) : [],
            pending: true,
            accepted: true,
            declined: true,
            tentative: true,
            planned_actions: true,
            follow_ups: true,
            currentViewName: 'Week',
            currentDate: new Date(),
            startDate: null,
            endDate: null,
            openOpportunityActionModal: false,
            modalData: {},
            mode: ADD,
            jobEmail: null,
            person: null,
            actionType: null,
            selectedAppointment: null,
            callCompleted: false,
            callMissed: false,
        };
    }

    componentDidMount() {
        const {resetCalendarLoader} = this.props;
        this.handleAddOrUpdateEvent();
        resetCalendarLoader();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            events,
            legacy_events,
            follow_ups,
            plannedAction,
            appointmentChangeCallback,
            selectedFollowUp,
        } = this.props;
        const {selectedAppointment, callMissed} = this.state;

        if (prevProps.events !== events || prevProps.legacy_events !== legacy_events || prevProps.follow_ups !== follow_ups) {
            this.setState({
                data: this.appointmentsData(events)
            });

            if (this.state.accepted ||
                this.state.pending ||
                this.state.tentative ||
                this.state.declined ||
                this.state.planned_actions ||
                this.state.follow_ups
            )

                this.handleFilter(this.state);
        }

        if (plannedAction) {

            if (!callMissed) {
                this.setState({actionType: FOLLOW_UP});
            }
        } else if (!callMissed) {
            this.setState({actionType: null});
        }

        this.handleAddOrUpdateEvent();

        if (prevState.selectedAppointment != selectedAppointment) {
            if (appointmentChangeCallback && selectedAppointment) {
                appointmentChangeCallback(selectedAppointment);
            }
        } else if (selectedFollowUp === null) {
            this.setState({selectedAppointment: null});
        }
    }

    handleAddOrUpdateEvent() {
        const {opportunity} = this.props;
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        const opportunityId = urlParams.get('opportunity_id');

        if (type === 'add_update_event' && opportunityId) {
            const _jobEmail = Object.values(opportunity.related_objects.jobs).filter(item => item.job_is_primary == 1);
            const _person = Object.values(opportunity.related_objects.persons)[0];

            this.setState({
                openOpportunityActionModal: true,
                jobEmail: _jobEmail,
                person: _person,
                actionType: PLANNED_ACTION,
                mode: EDIT,
                callMissed: true,
            });

            urlParams.delete('type');
            urlParams.delete('opportunity_id');

            const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${urlParams.toString()}`;
            window.history.replaceState({}, document.title, newUrl);
        }
    }

    handleAddOpportunityActionModalClose(refresh = false) {
        const {getPersonFollowUps} = this.props;

        this.setState({
            openOpportunityActionModal: false,
            callMissed: false,
        });

        if (refresh && this.state.person) {
            getPersonFollowUps(this.state.person.person_id)
        }
    };

    handleCurrentViewNameChange = (e) => {
        this.setState({currentViewName: e});
    };

    handleCurrentDateChange = (e) => {
        this.setState({currentDate: e});
    }

    handleFilter = ({accepted, pending, declined, tentative, planned_actions, follow_ups}) => {
        const {events} = this.props;
        const list = this.appointmentsData(events);

        const filteredList = list.filter((item) => {
            if (accepted && item.event_status_overall === ACCEPTED) {
                return true;
            }
            if (declined && item.event_status_overall === DECLINED) {
                return true;
            }

            if (pending && item.event_status_overall === PENDING)
                return true;

            if (tentative && item.event_status_overall === TENTATIVE)
                return true;

            if (follow_ups && item.event_status_overall === FOLLOW_UP)
                return true;

            return !!(item.event_status_overall === undefined && (planned_actions || follow_ups));


        }).filter(item => {
            if (planned_actions && (item.event_type === PLANNED_ACTION)) {
                return true;
            }

            if (follow_ups && item.event_type === FOLLOW_UP) {
                return true;
            }

            return !!(planned_actions && follow_ups);
        });

        this.setState({data: filteredList});
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.checked},
            () => this.handleFilter(this.state));
    };

    appointmentsData = (apiResData) => {
        const erpDataArray = [];
        if (!apiResData) {
            return erpDataArray;
        }

        const {legacy_events, follow_ups, user} = this.props;
        const synced_action_ids = {};
        const synced_follow_up_ids = {};

        apiResData.forEach((item) => {
            const {event_uid, attendees} = item;
            let action_id = null;
            let follow_up_id = null;
            let opportunity_id = null;
            let person_id = null;

            if (item.event_id) {
                if (item.event_id.indexOf('fw') > -1) {
                    let splitFollowUpId = item.event_id.split('__');
                    follow_up_id = splitFollowUpId[0];
                    person_id = splitFollowUpId[1];
                    synced_follow_up_ids[item.event_id] = true;
                } else {
                    let event_id = item.event_id.split('__');
                    action_id = event_id[0];
                    opportunity_id = event_id[1];
                    synced_action_ids[item.event_id] = true;
                }
            } else {
                return;
            }

            let tempObj = {}

            if (action_id) {
                tempObj['event_type'] = PLANNED_ACTION;
            } else if (follow_up_id) {
                tempObj['event_type'] = FOLLOW_UP;
            }

            tempObj['id'] = event_uid || item.event_id
            tempObj['id_type'] = event_uid ? 'event_uid' : 'event_id'
            tempObj['event_id'] = item.event_id
            tempObj['opportunity_id'] = opportunity_id ? opportunity_id : null;
            tempObj['person_id'] = person_id ? person_id : null;
            tempObj['calendar_id'] = item.calendar_id
            const startTime = new Date(item.start);
            const endTime = new Date(item.end);
            tempObj['startDate'] = startTime;
            tempObj['endDate'] = endTime;
            tempObj['participants'] = attendees.filter(e => e.email !== user.user_details.user_email);
            tempObj['title'] = tempObj['event_type'] === FOLLOW_UP ? `FW-${item.summary}` : item.summary;
            tempObj['summary'] = item?.description;
            tempObj['participation_status'] = item.participation_status;
            const status_accepted = attendees.some(e => e.status === ACCEPTED.toLowerCase() && e.email === item.job_email);
            const status_rejected = attendees.some(e => e.status === DECLINED.toLowerCase() && e.email === item.job_email);
            const status_tentative = attendees.some(e => e.status === TENTATIVE.toLowerCase() && e.email === item.job_email);

            if (status_accepted)
                tempObj['event_status_overall'] = ACCEPTED;
            else if (status_rejected)
                tempObj['event_status_overall'] = DECLINED;
            else if (status_tentative)
                tempObj['event_status_overall'] = TENTATIVE;
            else
                tempObj['event_status_overall'] = PENDING;

            let externalConvertedToInternal = legacy_events?.find((event) => event.opportunity_action_invite_uuid === item.event_id && event.event_synced === 0);

            if (externalConvertedToInternal) {
                delete synced_action_ids[item.event_id];
            }

            erpDataArray.push({...item, ...tempObj})
        });

        if (Array.isArray(legacy_events)) {
            legacy_events?.forEach((item, index) => {
                const {opportunity_action_invite_uuid,opportunity_action_due_time, opportunity_action_end_time, event_synced} = item;

                if (synced_action_ids[opportunity_action_invite_uuid] || item.event_synced === 1)
                    return;

                let tempObj = {};
                tempObj['id'] = index;
                let sDate = opportunity_action_due_time;
                tempObj['startDate'] = new Date(sDate?.slice(0, 4), parseInt(sDate?.slice(5, 7) - 1), sDate?.slice(8, 10), sDate?.slice(11, 13), sDate?.slice(14, 16), sDate?.slice(17, 19));

                let eDate = opportunity_action_end_time;

                if (eDate && typeof eDate === 'string') {
                    tempObj['endDate'] = new Date(eDate?.slice(0, 4), parseInt(eDate?.slice(5, 7) - 1), eDate?.slice(8, 10), eDate?.slice(11, 13), eDate?.slice(14, 16), eDate?.slice(17, 19));
                } else {
                    tempObj['endDate'] = new Date(tempObj['startDate']);
                    tempObj['endDate'].setMinutes(tempObj['endDate'].getMinutes() + 30);
                }

                tempObj['title'] = item.person_name;
                tempObj['opportunity_id'] = item.opportunity_id;
                tempObj['location'] = "Planned Actions";
                tempObj['event_type'] = PLANNED_ACTION;

                if (event_synced === 1) {
                    tempObj['event_status_overall'] = PENDING;
                }

                erpDataArray.push({...item, ...tempObj});
            });
        }

        if (Array.isArray(follow_ups)) {
            follow_ups?.forEach((item, index) => {
                const {follow_up_invite_uuid, follow_up_due_time, follow_up_end_time} = item;
                if (synced_follow_up_ids[follow_up_invite_uuid] || item.event_synced === 1)
                    return;

                let tempObj = {}
                tempObj['id'] = index
                let sDate = follow_up_due_time;
                tempObj['startDate'] = new Date(sDate.slice(0, 4), parseInt(sDate.slice(5, 7) - 1), sDate.slice(8, 10), sDate.slice(11, 13), sDate.slice(14, 16), sDate.slice(17, 19))
                let eDate = follow_up_end_time;

                if (eDate && typeof eDate === 'string') {
                    tempObj['endDate'] = new Date(eDate.slice(0, 4), parseInt(eDate.slice(5, 7) - 1), eDate.slice(8, 10), eDate.slice(11, 13), eDate.slice(14, 16), eDate.slice(17, 19));
                } else {
                    tempObj['endDate'] = new Date(tempObj['startDate']);
                    tempObj['endDate'].setMinutes(tempObj['endDate'].getMinutes() + 30);
                }

                tempObj['title'] = `FW-${item.person_name}`;
                tempObj['person_id'] = item.person_id;
                tempObj['location'] = "Follow ups";
                tempObj['event_type'] = FOLLOW_UP;
                tempObj['event_status_overall'] = FOLLOW_UP;

                erpDataArray.push({...item, ...tempObj});
            });
        }

        return erpDataArray;
    }

    handleCellClick = (data) => {
        const {opportunity} = this.props;
        const {openOpportunityActionModal} = this.state;
        const _jobEmail = Object.values(opportunity.related_objects.jobs).filter(item => item.job_is_primary == 1);
        const _person = Object.values(opportunity.related_objects.persons)[0];

        this.setState({
            openOpportunityActionModal: !openOpportunityActionModal,
            modalData: data,
            jobEmail: _jobEmail,
            person: _person
        });
    }

    WeekTimeTableCell = props => (
        <WeekView.TimeTableCell
            {...props}
            onDoubleClick={() => this.props.isClickable && this.handleCellClick(props)}
            onClick={() => this.props.isClickable && this.handleCellClick(props)}
        />
    );

    MonthTimeTableCell = props => (
        <MonthView.TimeTableCell
            {...props}
            onDoubleClick={() => this.props.isClickable && this.handleCellClick(props)}
            onClick={() => this.props.isClickable && this.handleCellClick(props)}
        />
    );

    DayTimeTableCell = props => (
        <DayView.TimeTableCell
            {...props}
            onDoubleClick={() => this.props.isClickable && this.handleCellClick(props)}
            onClick={() => this.props.isClickable && this.handleCellClick(props)}
        />
    );

    render() {
        const {data, currentViewName} = this.state;
        const {opportunity} = this.props;

        const AppointmentHeaderComponent = (props) => {
            const opportunity_id = props.appointmentData.opportunity_id;
            const handleGotoClick = () => {
                const {navigate} = this.props;
                navigate(`/opportunities/id/${opportunity_id}?tab=history`);
            };
            return <AppointmentTooltip.Header {...props}>
                {opportunity_id &&
                    <Button onClick={handleGotoClick}>Go to opportunity &gt;</Button>
                }
            </AppointmentTooltip.Header>;
        }

        const AppointmentContent = ({
                                        children,
                                        appointmentData,
                                        ...restProps
                                    }) => {
            let participants = appointmentData.participants ? [...appointmentData.participants] : [];
            if (appointmentData.organizer)
                participants = participants.filter(p => p.email !== appointmentData.organizer.email);


            this.setState({"selectedAppointment": appointmentData});

            return (
                <AppointmentTooltip.Content
                    {...restProps}
                    appointmentData={appointmentData}
                >

                    {participants?.length > 0 &&
                        <Container>
                            <Typography variant="h6">
                                <b>Participants</b>
                            </Typography>
                            <ParticipantList>
                                {participants.map((participant, index) => (
                                    <ParticipantItem key={index}>
                                        <ParticipationStatus status={participant.status}/>
                                        <ListItemText primary={participant.email}/>
                                    </ParticipantItem>
                                ))}
                            </ParticipantList>
                        </Container>
                    }
                </AppointmentTooltip.Content>
            )
        };

        const resources = [{
            fieldName: 'event_status_overall',
            title: 'Participation Status',
            instances: [
                {id: ACCEPTED, text: ACCEPTED, color: ACTION_STATUS_COLORS.Accepted},
                {id: PENDING, text: PENDING, color: ACTION_STATUS_COLORS.Pending},
                {id: DECLINED, text: DECLINED, color: ACTION_STATUS_COLORS.Declined},
                {id: TENTATIVE, text: TENTATIVE, color: ACTION_STATUS_COLORS.Tentative},
                {id: FOLLOW_UP, text: 'Follow Up', color: ACTION_STATUS_COLORS.FollowUp}
            ]
        }
        ];

        return (
            <>
                {((this.props.cronofyAuthorized && this.props.getAllEvents_loading) || this.props.calendarIsLoading) &&
                    <ShowProgress/>
                }
                <>
                    <Paper className={currentViewName.toLowerCase()}>
                        <Scheduler
                            data={data}
                            height={660}
                        >
                            <ViewState
                                onCurrentDateChange={this.handleCurrentDateChange}
                                defaultCurrentDate={formatDate(new Date())}
                                currentViewName={currentViewName}
                            />

                            <DayView
                                startDayHour={8}
                                endDayHour={20}
                                timeTableCellComponent={this.DayTimeTableCell}
                                dayScaleCellComponent={DayScaleCell}
                                timeScaleLabelComponent={TimeScaleLabel}
                            />
                            <WeekView
                                name="Week"
                                displayName="Week"
                                excludedDays={[0, 6]}
                                startDayHour={8}
                                endDayHour={20}
                                timeTableCellComponent={this.WeekTimeTableCell}
                                dayScaleCellComponent={DayScaleCell}
                                timeScaleLabelComponent={TimeScaleLabel}
                            />
                            <MonthView
                                timeTableCellComponent={this.MonthTimeTableCell}
                                startDayHour={8}
                                endDayHour={20}
                            />

                            <Toolbar/>
                            <DateNavigator/>
                            <TodayButton/>
                            <Appointments/>
                            <AppointmentTooltip
                                showCloseButton
                                headerComponent={AppointmentHeaderComponent}
                                contentComponent={AppointmentContent}
                            />

                            <Resources data={resources}/>
                            <div style={{display: 'flex', justifyContent: 'space-between', paddingTop: '12px'}}>
                                <div style={{marginLeft: '33px', textAlign: 'left'}}>
                                    <FormControlLabel
                                        label="Accepted"
                                        control={<Checkbox
                                            checked={this.state.accepted}
                                            onChange={this.handleChange}
                                            name={'accepted'}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />}
                                    />
                                    <FormControlLabel
                                        label="Pending"
                                        control={<Checkbox
                                            checked={this.state.pending}
                                            onChange={this.handleChange}
                                            name={'pending'}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />}
                                    />
                                    <FormControlLabel
                                        label="Rejected"
                                        control={<Checkbox
                                            checked={this.state.declined}
                                            onChange={this.handleChange}
                                            name={'declined'}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />}
                                    />
                                    <FormControlLabel
                                        label="Tentative"
                                        control={<Checkbox
                                            checked={this.state.tentative}
                                            onChange={this.handleChange}
                                            name={'tentative'}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />}
                                    />

                                    <FormControlLabel
                                        label="Planned Actions"
                                        control={<Checkbox
                                            checked={this.state.planned_actions}
                                            onChange={this.handleChange}
                                            name={'planned_actions'}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />}
                                    />

                                    <FormControlLabel
                                        label="Follow ups"
                                        control={<Checkbox
                                            checked={this.state.follow_ups}
                                            onChange={this.handleChange}
                                            name={'follow_ups'}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />}
                                    />
                                </div>
                                <ExternalViewSwitcher
                                    currentViewName={currentViewName}
                                    onChange={this.handleCurrentViewNameChange}
                                />
                            </div>
                        </Scheduler>

                    </Paper>
                    <div> FW - refers to Follow ups
                    </div>
                </>
                {(this.state.openOpportunityActionModal) && <AddOpportunityActionModal
                    open={this.state.openOpportunityActionModal}
                    tab={this.props.tab}
                    handleClose={this.handleAddOpportunityActionModalClose.bind(this)}
                    startDate={this.state.modalData.startDate}
                    endDate={this.state.modalData.endDate}
                    opportunity={opportunity}
                    handleTabChange={this.props.handleTabChange}
                    jobEmail={this.state.jobEmail}
                    person={this.state.person}
                    mode={this.state.mode}
                    actionType={this.state.actionType}
                    dateRange={this.props.dateRange}
                />
                }
            </>
        );
    }
}

function WithNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    return <Demo {...props} params={params} navigate={navigate}/>
}

const mapStateToProps = (state) => ({
    user: accountSelectors.user(state),
    isLoading: opportunitySelectors.isLoading(state),
    getAllEvents_loading: opportunitySelectors.getAllEvents_loading(state),
    getAllEvenets_inProgress: opportunitySelectors.getAllEvenets_inProgress(state),
    cronofyAuthorized: accountSelectors.cronofyAuthorized(state),
    calendarIsLoading: opportunitySelectors.calendarIsLoading(state),
    opportunity: opportunitySelectors.opportunity(state),
    plannedAction: opportunitySelectors.plannedActionResponse(state),
    followUps: contactSelectors.followUps(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        resetCalendarLoader: opportunityActions.resetCalendarLoader,
        getAllEvents: opportunityActions.getAllEvents,
        getPersonFollowUps: contactActions.getPersonFollowUps,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigate);

const ExternalViewSwitcher = ({
                                  currentViewName,
                                  onChange,
                              }) => (
    <div style={{width: '400px'}}>
        <Button style={{marginRight: '12px'}} onClick={() => onChange('Day')}
                variant={currentViewName === 'Day' ? 'contained' : 'text'} name={'Day'}>Day</Button>
        <Button onClick={() => onChange('Week')} variant={currentViewName === 'Week' ? 'contained' : 'text'}
                name={'Week'}>Week</Button>
        <Button style={{marginLeft: '12px'}} onClick={() => onChange('Month')}
                variant={currentViewName === 'Month' ? 'contained' : 'text'} name={'Month'}>Month</Button>
    </div>
);

function formatDate(date) {
    return moment(date).format("YYYY-MM-DD");
}